import React from "react";
import { useNavigate } from "react-router-dom";
import MainMenuItem from "app/components/MainMenuItem";
import Path from "app/route/Path";

function DepositContactMenuItem(props) {
  const { salonId } = props;

  const navigate = useNavigate();

  const onMenuItemClicked = () => {
    navigate(Path.salon.deposit.contact(salonId, 0));
  };

  return (
    <MainMenuItem
      itemTitleString="連絡する"
      onClick={onMenuItemClicked}
      size="100%"
    />
  );
}

export default DepositContactMenuItem;
